import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Roles } from '../constants/roles.constant';
import { LocalStorage } from '../constants/local-storage.constant';
import { LocalStorageService } from '../service/local-storage.service'

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {

  constructor(public jwtHelper: JwtHelperService,
    private localStorageService: LocalStorageService) {

  }

  public isAuthenticated(): boolean {
    const token = this.localStorageService.getData(LocalStorage.TOKEN);
    if (token === null) {
      return false;
    }
    return !this.jwtHelper.isTokenExpired(token);
  }

  public isAdministrator(): boolean {

    const role = this.CurrentUserRoleName();
    return (role !== undefined && role === Roles.ADMIN);
  }

  public CurrentUserRoleName(): string {
    const token = this.localStorageService.getData(LocalStorage.TOKEN);
    if (token === null) {
      return null;
    }
    const decodedToken = this.jwtHelper.decodeToken(token);
    return decodedToken['Role'];

  }

  public CurrentUserDesignation(): string {
    const token = this.localStorageService.getData('currentUser');
    const name = token.designationName;
    return name;

  }

  public CurrentUserFullName(): string {
    const token = this.localStorageService.getData(LocalStorage.TOKEN);
    if (token === null) {
      return undefined;
    }
    const decodedToken = this.jwtHelper.decodeToken(token);
    const name = decodedToken.UserName;
    return name;
  }
  public CurrentUserId(): number {
    const token = this.localStorageService.getData(LocalStorage.TOKEN);
    if (token === null) {
      return undefined;
    }
    const decodedToken = this.jwtHelper.decodeToken(token);
    const UserId = decodedToken.Id;
    return Number(UserId);
  }
  public CurrentUserEmployeeId(): number {
    const currentUser = this.localStorageService.getData(LocalStorage.CURRENT_USER);
    if (currentUser === null) {
      return undefined;
    }
   
    return Number(currentUser.employeeId);
  }

  public CurrentUserCompanyId(): string {
    const token = this.localStorageService.getData(LocalStorage.TOKEN);
    if (token === null) {
      return undefined;
    }
    const decodedToken = this.jwtHelper.decodeToken(token);
    const CompanyId = decodedToken.CompanyId;
    return CompanyId;
  }

  public CurrentUserRoleId(): number {
    const token = this.localStorageService.getData(LocalStorage.TOKEN);
    if (token === null) {
      return undefined;
    }
    const decodedToken = this.jwtHelper.decodeToken(token);
    const RoleId = decodedToken.RoleId;
    return Number(RoleId);
  }





  public SoliderNumber(): string {
    const soliderId = this.CurrentUserId();
    if (soliderId === undefined) {
      return '';
    }
    const solidernumber = soliderId.toString().padStart(5, '0');
    return (solidernumber);
  }

}
